import React, { useMemo } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import CloseIcon from "../../asset/misc/Close";

import "./Modal.css";

function Modal (props) {
    const { children, open, onClose, className, close = true } = props;

    const closeIconNode = useMemo(() => {
        let node = null;

        if (close) {
            node = (
                <div className="dialog-panel__close-icon-wrapper">
                    <span
                        className="dialog-panel__close-icon"
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </span>
                </div>
            );
        }

        return node;
    }, [close, onClose]);

    return (
        <Dialog
            open={open}
            as="div"
            className="dialog"
            onClose={onClose}
            onKeyDown={ props?.onKeyDown || (()=>{}) }
        >
            <div className="dialog-overlay" />

            <div className="dialog__wrapper-outer">
                <div className="dialog__wrapper-inner">
                    <DialogPanel className={`dialog-panel${className ? ` ${className}` : ''}`}>
                        {closeIconNode}
                        
                        {children}
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
}

export default Modal;
